import { Localize } from "components/service";




const TeamType = ({ type }: { type: string }) =>
{
    return type === "full" ? (
        <Localize>FORMS.Select_OptionLabel_Full</Localize>
    ) : (
        <Localize>FORMS.Select_OptionLabel_CAD</Localize>
    );
};

export default TeamType;